// Thanks iOS again
// This is needed because iOS has arrow buttons to toggle between inputs
import { isMobile } from 'shared/util/mobile';

export const getAllInputsOnPage = () =>
    // @ts-expect-error not sure what the issue is here
    Array.from(document.getElementsByTagName('input')).concat(Array.from(document.getElementsByTagName('select')));

export function disableInputsExcept(currentActiveInput?: string) {
    if (!isMobile()) {
        return null;
    }
    try {
        getAllInputsOnPage()
            .filter((obj) => obj.id !== currentActiveInput)
            .forEach((element) => {
                element.readOnly = true;
            });
    } catch (e) {
        return null;
    }
    return null;
}

export function enableInputs() {
    if (!isMobile()) {
        return null;
    }
    try {
        getAllInputsOnPage().forEach((element) => {
            element.readOnly = false;
        });
    } catch (e) {
        return null;
    }
    return null;
}
